const normalizeReviewState = (state) =>
  (state || '').toString().toUpperCase().replace(/-/g, '_');

/**
 * First-pass PR: the chronologically first review submission must be APPROVED.
 */
export function isFirstPassApprovedPR(reviews) {
  if (!Array.isArray(reviews) || reviews.length === 0) {
    return false;
  }

  const sortedReviews = [...reviews]
    .filter((review) => review?.reviewDate)
    .sort((a, b) => new Date(a.reviewDate) - new Date(b.reviewDate));

  if (sortedReviews.length === 0) {
    return false;
  }

  return normalizeReviewState(sortedReviews[0].reviewState) === 'APPROVED';
}

export function buildStandupPRSummaryTooltip({ prLabel, prPluralShortLabel, prShortLabel }) {
  const tipTitle = 'color:#F8FAFC;font-weight:700;';
  const tipTotal = 'color:#48A7FF;font-weight:700;';
  const tipOpen = 'color:#8349CF;font-weight:700;';
  const tipMerged = 'color:#F59F12;font-weight:700;';
  const tipClosed = 'color:#32A136;font-weight:700;';
  const tipMetric = 'color:#E2E8F0;font-weight:700;';
  const tipPass = 'color:#34D399;font-weight:700;';
  const tipB = 'color:#CBD5E1;';
  const tipF = 'color:#94A3B8;font-style:italic;';

  return `<div style="padding:4px 6px;text-align:left;line-height:1.5;">
<span style="${tipTitle}font-size:14px;display:block;margin-bottom:10px;">${prLabel} Summary</span>
<span style="${tipTotal}">Total ${prPluralShortLabel}:</span> <span style="${tipB}">All ${prPluralShortLabel.toLowerCase()} linked to issues in the selected sprint or release. Click the count to show all ${prPluralShortLabel.toLowerCase()} in the table.</span><br/><br/>
<span style="${tipOpen}">Open ${prPluralShortLabel}:</span> <span style="${tipB}">${prPluralShortLabel} still open (not merged or closed). Click the count to filter the table.</span><br/>
<span style="${tipB}">• </span><span style="${tipOpen}">Reviewed:</span> <span style="${tipB}">Open ${prPluralShortLabel.toLowerCase()} with at least one review. Click to filter the table.</span><br/>
<span style="${tipB}">• </span><span style="${tipOpen}">Unreviewed:</span> <span style="${tipB}">Open ${prPluralShortLabel.toLowerCase()} with no reviews. Click to filter the table.</span><br/><br/>
<span style="${tipMerged}">Merged ${prPluralShortLabel}:</span> <span style="${tipB}">${prPluralShortLabel} successfully merged into the target branch. Click the count to filter the table.</span><br/><br/>
<span style="${tipClosed}">Closed W/O Merge:</span> <span style="${tipB}">${prPluralShortLabel} closed without merge (abandoned or rejected). Click the count to filter the table.</span><br/><br/>
<span style="${tipMetric}">Average Time To Merge:</span> <span style="${tipB}">Average working time from ${prShortLabel} creation to merge for merged ${prPluralShortLabel.toLowerCase()} that had at least one review.</span><br/>
<span style="${tipF}">Formula: Sum of working hours (9 hrs/day, excluding weekends) from created date to merged date ÷ Number of merged reviewed ${prPluralShortLabel.toLowerCase()}.</span><br/><br/>
<span style="${tipPass}">First-Time Pass Rate:</span> <span style="${tipB}">Share of reviewed ${prPluralShortLabel.toLowerCase()} (open or merged) whose first review submission is APPROVED. Shown as percentage with passed count (e.g. 100% · 6 ${prPluralShortLabel}). Click the count to filter the table.</span><br/>
<span style="${tipF}">Formula: (First-Time Passed ${prPluralShortLabel} ÷ Total Reviewed ${prPluralShortLabel}) × 100. Only counts when the first review state is APPROVED (not COMMENTED or CHANGES_REQUESTED first).</span>
</div>`;
}
